// ============================================================================
// tregimi.js — MOTORI I RRËFIMIT
//
// Nga një pemë familjeje nxjerr një HISTORI: momentet, kapitujt, brezat dhe
// vendet. Asnjë fakt i ri nuk lind këtu — vetëm zgjidhet, grupohet dhe
// renditet ajo që tashmë ekziston.
//
// ---------------------------------------------------------------------------
// PSE NJË SKEDAR I VETËM, I PASTËR
//
// I njëjti motor do t'i shërbejë turneut me zë DHE Librit të Familjes. Po ta
// shkruanim dy herë, brenda pak muajsh libri dhe zëri do të tregonin dy histori
// të ndryshme për të njëjtën familje — dhe askush s'do ta dinte cila është e
// vërteta. Prandaj: funksione të pastra, pa React, pa rrjet, pa gjendje.
//
// Dhe prandaj provohet me Node, jo me sy. Shih `tregimi.test.mjs`.
//
// ---------------------------------------------------------------------------
// RREGULLI QË E NDAN HISTORINË NGA KRONOLOGJIA
//
//     KRONOLOGJIA:  çfarë ndodhi dhe kur.
//     HISTORIA:     çfarë ndodhi, pse kishte rëndësi, dhe si e ndryshoi familjen.
//
// Pra jo çdo datëlindje është moment. Një ngjarje hyn te historia vetëm kur
// mbart një nga këto pesha — dhe secila është e shpjegueshme me fjalë:
//
//   1. E SHKROI NJË NJERI (100)  — ngjarjet familjare. Dikush u ul dhe e shkroi;
//      kjo është shenja më e fortë që ekziston, dhe nuk tejkalohet nga asnjë
//      llogaritje e jona.
//   2. RRËNJA (90)               — lindja e paraardhësit më të vjetër. Aty nis
//      gjithçka që dimë; pa të, historia fillon në mes.
//   3. ZHVENDOSJA (80)           — hera e parë që një fëmijë lind në një vend të
//      ri. Familja s'e njofton kurrë shpërnguljen; ajo duket vetëm te vendlindja
//      e fëmijës tjetër.
//   4. HISTORI E SHKRUAR (70/65) — lindja, dhe vdekja, e dikujt për të cilin
//      familja ka shkruar diçka. Teksti ekziston; hapi ka çfarë të thotë.
//   5. BREZ I RI (60)            — fëmija i parë i një brezi. Ndryshimi më i
//      qetë dhe më i madh që i ndodh një familjeje.
//
// Gjithçka tjetër mbetet te kronologjia. Kjo NUK është fshehje: kronologjia i
// tregon të gjitha, dhe secili moment e mban të shkruar pse u zgjodh (`pse`).
// ============================================================================

const PESHA = {
  shkruar_nga_njeri: 100,
  rrenja: 90,
  zhvendosje: 80,
  lindje_me_histori: 70,
  vdekje_me_histori: 65,
  brez_i_ri: 60,
};

const viti = (d) => (d ? parseInt(String(d).slice(0, 4), 10) || null : null);
const gjalle = (p) => p && !p.deleted_at;
const emriPlote = (p) =>
  [p?.first_name, p?.last_name].filter(Boolean).join(" ").trim() || "(pa emër)";
// "Vermosh, Kelmend" → "Vermosh". Vendi krahasohet me rrënjën e emrit sepse
// "Gjakovë" te fusha dhe "Gjakova" te fjalia janë i njëjti vend.
const vendiKryesor = (s) => String(s || "").split(",")[0].trim();
const rrenjaEVendit = (s) => vendiKryesor(s).toLowerCase().slice(0, 5);

// GJAKU, JO MARTESA (gjetur nga vetë prova, 26 gusht)
//
// Vendlindja e një nuseje a dhëndri të ardhur tregon nga ERDHI AI — jo ku
// shkoi familja. Pa këtë dallim, Gjakova e Mirlindës dilte si "zhvendosje e
// familjes", dhe historia thoshte diçka që s'kishte ndodhur kurrë.
//
// Nëse asnjë person s'e ka fushën (bazë e vjetër), kthehemi te të gjithë — më
// mirë një zhvendosje e tepërt sesa asnjë udhëtim fare.
const eshteGjak = (p) =>
  p.member_kind ? p.member_kind === "blood"
  : p.branch ? p.branch === "core"
  : true;
const vetemGjaku = (lista) => {
  const g = lista.filter(eshteGjak);
  return g.length ? g : lista;
};

// ---------------------------------------------------------------------------
// KUSH PËRMENDET NË NJË NGJARJE FAMILJARE
//
// Raportim i pronarit, 27 gusht:
//
//     "tregon se si Naimi u martua me Fatimen në 1966, pastaj thotë '4 vjet më
//      vonë lindi Fatimja' — që ishte 4 vjet më e re se Naimi, po nuk lindi
//      pasi u martuan."
//
// Te kjo familje ka DY Fatime. Të dyja fjalitë ishin të vërteta veç e veç;
// fjala "më vonë" i bashkoi në një person. Rrëfimi gënjeu pa thënë asnjë fakt
// të rremë — dhe kjo është e vetmja mënyrë si mund të gënjejë një rrëfim i
// ndërtuar nga të dhëna të sakta.
//
// Që lidhësi të dijë KUR të lidhë, duhet të dijë PËR KË flitet. Ngjarjet
// familjare s'kanë lidhje me person te baza (kufi i njohur, i shkruar te radha
// e punës), por TITULLI dhe PËRSHKRIMI i përmendin emrat. Aq mjafton.
//
// ---------------------------------------------------------------------------
// SHQIPJA I LAKON EMRAT
//
// "Naimi", "Naimit", "Fatimen", "Leartit" — prandaj krahasimi bëhet me rrënjë,
// jo me varg të plotë. Kufiri prej katër shkronjash shtesë i mban rasat pa i
// hapur derën fjalëve të tjera.
//
// DHE KUR EMRI PËRSËRITET, NUK HAMENDËSOHET. Tri "Kaltrina" te një familje do
// të thotë se "Kaltrina" nuk identifikon askënd; atëherë lidhja nuk bëhet fare,
// përveçse kur teksti e shkruan emrin e plotë. Më mirë një ngjarje pa pronar
// sesa historia e njërës grua e vënë mbi tjetrën.
// ---------------------------------------------------------------------------

const pastroFjalen = (f) =>
  String(f || "").toLowerCase().replace(/[^\p{L}]/gu, "");

export function indeksiIEmrave(people) {
  const lista = Object.values(people || {}).filter(gjalle);
  const sipasEmrit = new Map();   // rrënja e emrit → [id]
  // EDHE EMRI I PLOTË MUND TË PËRSËRITET (gjetur nga prova, 27 gusht).
  // Te familja e provës të dyja Fatimet quhen "Fatime Kelmendi". Një `Map`
  // emër→id do ta kishte mbivendosur njërën mbi tjetrën pa asnjë shenjë, dhe
  // ngjarja do t'i ishte veshur asaj që u shkrua e fundit — pra rastësisë.
  const plote = new Map();        // "emri mbiemri" → [id]
  lista.forEach((p) => {
    const e = pastroFjalen(p.first_name);
    if (e) {
      if (!sipasEmrit.has(e)) sipasEmrit.set(e, []);
      sipasEmrit.get(e).push(p.id);
    }
    const pl = [p.first_name, p.last_name].filter(Boolean).join(" ").toLowerCase().trim();
    if (pl && p.last_name) {
      if (!plote.has(pl)) plote.set(pl, []);
      plote.get(pl).push(p.id);
    }
  });
  return { sipasEmrit, plote, lista };
}

export function personatENjeTeksti(teksti, indeksi) {
  const t0 = String(teksti || "");
  if (!t0.trim() || !indeksi) return [];
  const gjetur = new Set();

  // 1. Emri i plotë — i sigurt edhe kur emri i parë përsëritet.
  const iVogel = t0.toLowerCase();
  indeksi.plote.forEach((ids, pl) => {
    if (ids.length === 1 && iVogel.includes(pl)) gjetur.add(ids[0]);
  });

  // 2. Emri i parë, me rrënjë — vetëm kur ai emër i takon një personi të vetëm.
  const fjalet = t0.split(/\s+/).map(pastroFjalen).filter(Boolean);
  indeksi.sipasEmrit.forEach((ids, rrenja) => {
    if (ids.length !== 1) return;                 // emër i përsëritur → hesht
    if (rrenja.length < 4) {
      if (fjalet.includes(rrenja)) gjetur.add(ids[0]);
      return;
    }
    const perputh = fjalet.some(
      (f) => f.startsWith(rrenja) && f.length - rrenja.length <= 4
    );
    if (perputh) gjetur.add(ids[0]);
  });

  return [...gjetur];
}

// ---------------------------------------------------------------------------
// FUSHA E RRËFIMIT — kush hyn te historia dhe kush jo
//
// Kërkesë e pronarit, 27 gusht:
//
//     "do doja të mund të vendos edhe atribute — fillo tregimin nga ky
//      paraardhës edhe ndalu te ky, edhe vetëm personat e përfshirë fokusohet
//      tregimi. pastaj tregim vetëm për x person, pastaj për x person plus
//      pasardhësit."
//
// Pra jo një filtër pamjeje: një PREREJE E VËRTETË e familjes, e bërë PARA se
// të zgjidhet ndonjë moment. Gjithçka poshtë saj — brezat, vendet, kapitujt —
// llogaritet mbi atë prerje, prandaj një rrëfim i ngushtuar nuk është një
// rrëfim i madh me gjëra të fshehura: është një rrëfim tjetër, i plotë në
// vetvete. Brezi 1 i tij është pikërisht personi nga i cili nise.
//
//   gjithe         E gjithë familja. Parazgjedhja.
//   person         Vetëm ai person.
//   pasardhesit    Ai dhe të gjithë pasardhësit e tij.
//   paraardhesit   Ai dhe të gjithë paraardhësit e tij.
//   vija           Nga një paraardhës DERI te një pasardhës: vetëm ata që
//                  qëndrojnë në rrugën mes të dyve.
//
// BASHKËSHORTËT HYJNË, PRINDËRIT E TYRE JO. Një rrëfim familjeje pa nuset e
// dhëndurët nuk është rrëfim familjeje; por po t'i ndiqnim edhe ata lart, një
// "vetëm Learti dhe pasardhësit" do të përfundonte duke treguar krejt
// Gjakovën. Kufiri vihet me vetëdije te një hap.
// ---------------------------------------------------------------------------

const gjithePersonat = (people) => Object.values(people || {}).filter(gjalle);

// Përhapje pa lak. Kufiri 200 nuk është kapak zgjedhjeje — është mbrojtje nga
// një lak prind↔fëmijë te të dhëna të prishura, njësoj si te `ndajBrezat`.
function eci(fillimi, hapi) {
  const pare = new Set(fillimi);
  let radha = [...fillimi], rrotull = 0;
  while (radha.length && rrotull++ < 200) {
    const tani = radha;
    radha = [];
    tani.forEach((id) => {
      hapi(id).forEach((tj) => { if (tj && !pare.has(tj)) { pare.add(tj); radha.push(tj); } });
    });
  }
  return pare;
}

const femijetE = (map) => {
  const f = {};
  Object.values(map).forEach((p) => {
    (p.parent_ids || []).forEach((id) => { (f[id] = f[id] || []).push(p.id); });
  });
  return f;
};

export function zgjidhFushen(people, fusha) {
  const lloj = fusha?.lloj || "gjithe";
  const lista = gjithePersonat(people);
  const map = Object.fromEntries(lista.map((p) => [p.id, p]));
  // Edhe kur nuk del asgjë, spirancat kthehen: pa to, fjalia që shpjegon
  // dështimin do të ishte "… nuk zbret nga …" — pa asnjë emër.
  const bosh = (arsyeja) => ({
    people: {}, lloj, bosh: true, arsyeja, saJashte: lista.length,
    nga: fusha?.nga || fusha?.person || null,
    deri: fusha?.deri || null,
  });

  if (lloj === "gjithe" || !lista.length) {
    return { people: map, lloj: "gjithe", bosh: !lista.length, arsyeja: null, nga: null, deri: null, saJashte: 0 };
  }

  const femijet = femijetE(map);
  const poshte = (id) => eci([id], (x) => femijet[x] || []);
  const lart = (id) => eci([id], (x) => (map[x]?.parent_ids || []).filter((y) => map[y]));

  let zgjedhur;
  let nga = null, deri = null;

  if (lloj === "vija") {
    nga = fusha?.nga; deri = fusha?.deri;
    if (!map[nga] || !map[deri]) return bosh("mungon_personi");
    if (nga === deri) { zgjedhur = new Set([nga]); }
    else {
      const posht = poshte(nga), larte = lart(deri);
      // Prerja e dy bashkësive = pikërisht ata që janë njëkohësisht pasardhës
      // të `nga` dhe paraardhës të `deri`. Kjo i mban të gjitha rrugët, jo
      // vetëm më të shkurtrën — te një pemë e vërtetë ka më shumë se një.
      zgjedhur = new Set([...posht].filter((id) => larte.has(id)));
      // Nëse `deri` nuk zbret nga `nga`, prerja del bosh. Kjo NUK duhet
      // heshtur me një rrëfim bosh: është zgjedhje e pamundur, dhe përdoruesi
      // duhet ta dijë pse — përndryshe do të mendojë se programi u prish.
      if (!zgjedhur.size) return bosh("nuk_lidhen");
      zgjedhur.add(nga); zgjedhur.add(deri);
    }
  } else {
    const kush = fusha?.person || fusha?.nga;
    if (!map[kush]) return bosh("mungon_personi");
    nga = kush;
    zgjedhur = lloj === "pasardhesit" ? poshte(kush)
             : lloj === "paraardhesit" ? lart(kush)
             : new Set([kush]);
  }

  // Bashkëshortët — një hap, jo më shumë.
  if (fusha?.meBashkeshorte !== false) {
    [...zgjedhur].forEach((id) => {
      (map[id]?.spouse_ids || []).forEach((sid) => { if (map[sid]) zgjedhur.add(sid); });
    });
  }

  const out = {};
  zgjedhur.forEach((id) => { if (map[id]) out[id] = map[id]; });
  return {
    people: out, lloj, bosh: !Object.keys(out).length,
    arsyeja: Object.keys(out).length ? null : "bosh",
    nga, deri, saJashte: lista.length - Object.keys(out).length,
  };
}

// NGJARJET FAMILJARE NËN NJË FUSHË TË NGUSHTË
//
// `family_history_events` nuk ka lidhje me person — kjo dihet dhe është
// shkruar te radha e punës. Pra kur rrëfimi ngushtohet te një degë, s'kemi si
// ta dimë nëse "Rruga për Kukës" i takon asaj dege apo tjetrës.
//
// Zgjedhja e ndershme është dritarja e viteve: hyjnë ato ngjarje që ndodhën
// ndërsa këta njerëz jetonin. Është heuristikë, dhe e pranoj si të tillë —
// por alternativa (t'i heqim të gjitha) do t'i hiqte rrëfimit pikërisht atë
// që ka peshën më të madhe: fjalët që i shkroi vetë familja.
export function ngjarjetENjeFushe(ngjarjet, people, fusha) {
  if (!fusha || (fusha.lloj || "gjithe") === "gjithe") return ngjarjet || [];
  const vitet = gjithePersonat(people)
    .flatMap((p) => [viti(p.birth_date), viti(p.death_date)]).filter(Boolean);
  if (!vitet.length) return ngjarjet || [];
  const nga = Math.min(...vitet), deri = Math.max(...vitet);
  return (ngjarjet || []).filter((e) => {
    const y = viti(e.event_date);
    return !y || (y >= nga && y <= deri);
  });
}

// ---------------------------------------------------------------------------
// BREZAT — nga lidhjet, jo nga datat
//
// Brezi 1 = kush s'ka prind brenda familjes. Pastaj zbritet nga prindi te
// fëmija. Datat NUK përdoren: te pemët e vërteta ka fëmijë më të vjetër se
// xhaxhai i tyre, dhe një ndarje sipas dekadave do t'i përzinte brezat.
// ---------------------------------------------------------------------------
export function ndajBrezat(people) {
  const lista = Object.values(people || {}).filter(gjalle);
  const map = Object.fromEntries(lista.map((p) => [p.id, p]));
  const brezi = {};
  const rrenjet = lista.filter(
    (p) => !(p.parent_ids || []).some((id) => map[id])
  );
  rrenjet.forEach((p) => { brezi[p.id] = 1; });

  // Përhapje në gjerësi. Kufiri 40 nuk është kapak — është mbrojtje nga një
  // lak prind↔fëmijë te të dhëna të prishura, që do ta ngrinte aplikacionin.
  let ndryshoi = true, rrotull = 0;
  while (ndryshoi && rrotull++ < 40) {
    ndryshoi = false;
    lista.forEach((p) => {
      const prinderit = (p.parent_ids || []).map((id) => brezi[id]).filter(Boolean);
      if (!prinderit.length) return;
      const i_ri = Math.max(...prinderit) + 1;
      if (brezi[p.id] !== i_ri) { brezi[p.id] = i_ri; ndryshoi = true; }
    });
  }
  lista.forEach((p) => { if (!brezi[p.id]) brezi[p.id] = 1; });

  const sa = Math.max(1, ...Object.values(brezi));
  const out = [];
  for (let n = 1; n <= sa; n++) {
    const anetaret = lista.filter((p) => brezi[p.id] === n)
      .sort((a, b) => String(a.birth_date || "9999").localeCompare(String(b.birth_date || "9999")));
    if (!anetaret.length) continue;
    const vitet = anetaret.map((p) => viti(p.birth_date)).filter(Boolean);
    const vendet = [...new Set(anetaret.map((p) => vendiKryesor(p.birth_place)).filter(Boolean))];
    out.push({
      nr: n,
      personIds: anetaret.map((p) => p.id),
      emrat: anetaret.slice(0, 3).map(emriPlote),
      sa: anetaret.length,
      nga: vitet.length ? Math.min(...vitet) : null,
      deri: vitet.length ? Math.max(...vitet) : null,
      vendet,
      // Kush ka histori të shkruar te ky brez — libri dhe turneu i preferojnë.
      meHistori: anetaret.filter((p) => String(p.bio || "").trim()).map((p) => p.id),
    });
  }
  return { brezat: out, brezi };
}

// ---------------------------------------------------------------------------
// VENDET — udhëtimi i familjes, i nxjerrë nga vendlindjet
//
// Një familje nuk e shënon kurrë "u shpërngulëm". Shpërngulja duket vetëm te
// vendlindja e fëmijës së parë që lindi tjetërkund.
// ---------------------------------------------------------------------------
export function ndertoUdhetimin(people) {
  const lista = vetemGjaku(Object.values(people || {}).filter(gjalle))
    .filter((p) => vendiKryesor(p.birth_place))
    .sort((a, b) => String(a.birth_date || "9999").localeCompare(String(b.birth_date || "9999")));

  const sipas = new Map();
  lista.forEach((p) => {
    const v = vendiKryesor(p.birth_place);
    if (!sipas.has(v)) sipas.set(v, { emri: v, personIds: [], vitet: [] });
    const rec = sipas.get(v);
    rec.personIds.push(p.id);
    const y = viti(p.birth_date);
    if (y) rec.vitet.push(y);
  });

  return [...sipas.values()]
    .map((r) => ({
      emri: r.emri,
      personIds: r.personIds,
      sa: r.personIds.length,
      nga: r.vitet.length ? Math.min(...r.vitet) : null,
      deri: r.vitet.length ? Math.max(...r.vitet) : null,
    }))
    .sort((a, b) => (a.nga || 9999) - (b.nga || 9999));
}

// ---------------------------------------------------------------------------
// MOMENTET — zgjedhja
//
// Kthen ngjarje me `pesha` dhe `pse`. `pse` nuk është dekor: ai është arsyeja
// që i lejon familjes ta kundërshtojë zgjedhjen tonë, dhe neve ta shpjegojmë.
// ---------------------------------------------------------------------------
export function zgjidhMomentet({ people, ngjarjet = [], maks = 24 }) {
  const lista = Object.values(people || {}).filter(gjalle);
  const map = Object.fromEntries(lista.map((p) => [p.id, p]));
  const { brezi } = ndajBrezat(people);
  const out = [];

  // 1. Ngjarjet familjare — të shkruara nga një njeri.
  const indeksi = indeksiIEmrave(people);
  (ngjarjet || []).forEach((e) => {
    const y = viti(e.event_date);
    if (!y && !e.title) return;
    // AKTORËT, JO `personIds`. Emri i dytë me qëllim: `personIds` e çon turneun
    // te profili i personit dhe e qendërzon pemën mbi të. Një ngjarje familjare
    // s'duhet ta bëjë kurrë atë — ajo është e familjes, jo e njërit. `aktoret`
    // shërben vetëm që rrëfimtari të dijë nëse fija e tregimit vazhdon.
    let aktoret = personatENjeTeksti(`${e.title || ""} ${e.description || ""}`, indeksi);
    // Një ngjarje e datuar PARA se dikush të lindte nuk mund të flasë për të.
    // Përputhja ishte e rreme; hiqet pa zhurmë.
    if (y) aktoret = aktoret.filter((id) => {
      const l = viti(map[id]?.birth_date);
      return !l || l <= y;
    });
    out.push({
      id: `nf-${e.id || e.title}`,
      vit: y, lloj: "familje", pesha: PESHA.shkruar_nga_njeri,
      titull: e.title || "",
      teksti: String(e.description || "").trim(),
      personIds: [], aktoret, vend: null,
      pse: "shkruar_nga_familja",
    });
  });

  // 2. Rrënja — lindja e paraardhësit më të vjetër me datë.
  const meDate = lista.filter((p) => viti(p.birth_date))
    .sort((a, b) => viti(a.birth_date) - viti(b.birth_date));
  const rrenja = meDate.find((p) => brezi[p.id] === 1) || meDate[0];
  if (rrenja) {
    out.push({
      id: `rr-${rrenja.id}`, vit: viti(rrenja.birth_date), lloj: "lindje",
      pesha: PESHA.rrenja, titull: emriPlote(rrenja),
      teksti: String(rrenja.bio || "").trim(),
      personIds: [rrenja.id], vend: vendiKryesor(rrenja.birth_place) || null,
      pse: "paraardhesi_me_i_vjeter",
    });
  }

  // 3. Zhvendosjet — fëmija i parë I GJAKUT që lind në një vend të ri.
  const pare = new Set();
  vetemGjaku(meDate).forEach((p) => {
    const v = rrenjaEVendit(p.birth_place);
    if (!v || pare.has(v)) return;
    pare.add(v);
    if (pare.size === 1) return; // vendi i parë s'është zhvendosje, është origjina
    out.push({
      id: `zh-${p.id}`, vit: viti(p.birth_date), lloj: "zhvendosje",
      pesha: PESHA.zhvendosje, titull: vendiKryesor(p.birth_place),
      teksti: "", personIds: [p.id], vend: vendiKryesor(p.birth_place),
      pse: "lindja_e_pare_ne_nje_vend_te_ri",
    });
  });

  // 4. Kush ka histori të shkruar — lindja, dhe vdekja nëse dihet.
  //
  // NJË LINDJE, NJË MOMENT (gjetur nga prova e rrëfimtarit, 27 gusht)
  //
  // Kur i njëjti person e hap një vend të ri DHE ka histori të shkruar, deri
  // sot dilnin dy momente për të njëjtën lindje. Te libri kjo dukej si
  // përsëritje; te zëri dëgjohej si belbëzim:
  //
  //     "Më 1969 lindi Learti — po jo në Vermosh, në Pejë."
  //     "Në të njëjtin vit, Learti lindi në Pejë më 1969."
  //
  // Zhvendosja peshon më shumë dhe e mban vendin e vet; historia e shkruar
  // hyn brenda saj. Një lindje, një moment, gjithçka që dimë për të.
  lista.filter((p) => String(p.bio || "").trim()).forEach((p) => {
    const yl = viti(p.birth_date);
    const zh = out.find((m) => m.personIds[0] === p.id && m.lloj === "zhvendosje");
    if (zh) { if (!zh.teksti) zh.teksti = String(p.bio).trim(); return; }
    if (yl && !out.some((m) => m.personIds[0] === p.id && m.lloj === "lindje")) {
      out.push({
        id: `hl-${p.id}`, vit: yl, lloj: "lindje", pesha: PESHA.lindje_me_histori,
        titull: emriPlote(p), teksti: String(p.bio).trim(),
        personIds: [p.id], vend: vendiKryesor(p.birth_place) || null,
        pse: "ka_histori_te_shkruar",
      });
    }
    const yv = viti(p.death_date);
    if (yv) {
      out.push({
        id: `hv-${p.id}`, vit: yv, lloj: "vdekje", pesha: PESHA.vdekje_me_histori,
        titull: emriPlote(p), teksti: "", personIds: [p.id], vend: null,
        pse: "ndarja_e_dikujt_me_histori",
      });
    }
  });

  // 5. Fillimi i çdo brezi — fëmija i parë i tij.
  const { brezat } = ndajBrezat(people);
  brezat.filter((b) => b.nr > 1).forEach((b) => {
    const iPari = b.personIds.map((id) => map[id]).filter((p) => viti(p.birth_date))[0];
    if (!iPari) return;
    if (out.some((m) => m.personIds[0] === iPari.id)) return;
    out.push({
      id: `br-${b.nr}`, vit: viti(iPari.birth_date), lloj: "brez",
      pesha: PESHA.brez_i_ri, titull: emriPlote(iPari), teksti: "",
      personIds: [iPari.id], vend: vendiKryesor(iPari.birth_place) || null,
      brez: b.nr, pse: "fillimi_i_nje_brezi",
    });
  });

  // Renditje sipas peshës, prerje te tavani, pastaj radhë kronologjike — sepse
  // një histori tregohet me kohën, jo me rëndësinë.
  const teZgjedhurit = out
    .filter((m) => m.vit)
    .sort((a, b) => b.pesha - a.pesha || a.vit - b.vit)
    .slice(0, maks)
    .sort((a, b) => a.vit - b.vit || b.pesha - a.pesha);

  // Dy momente të të njëjtit vit e të të njëjtit lloj janë përsëritje.
  const pa = [];
  teZgjedhurit.forEach((m) => {
    const dyfish = pa.some((x) => x.vit === m.vit && x.lloj === m.lloj && x.titull === m.titull);
    // Çdo moment e mban të shkruar për kë flet. Rrëfimtari e përdor këtë — dhe
    // vetëm këtë — për të vendosur nëse fija vazhdon apo nis një tjetër.
    if (!dyfish) pa.push({ ...m, aktoret: m.aktoret || m.personIds || [] });
  });
  return pa;
}

// ---------------------------------------------------------------------------
// KAPITUJT — ku pritet historia
//
// Kapitulli i ri nis aty ku familja mori drejtim tjetër: një zhvendosje, ose
// fillimi i një brezi. Nëse s'ka asnjë të tillë, pritet te boshllëqet më të
// gjata mes momenteve — sepse edhe heshtja është ndarje kapitulli.
//
// Titujt vijnë nga një fjalor i vogël i lidhur me SHKAKUN e prerjes; nuk
// shpiken. `celes` u kalohet përkthimeve, që motori të mbetet pa gjuhë.
// ---------------------------------------------------------------------------
export function ndajKapitujt(momentet, { maksKapituj = 6 } = {}) {
  if (!momentet.length) return [];

  const prerje = new Set([0]);
  momentet.forEach((m, i) => {
    if (i === 0) return;
    if (m.lloj === "zhvendosje" || m.lloj === "brez") prerje.add(i);
  });

  // Shumë prerje → mbaji ato me hendekun më të madh kohor para tyre.
  let pikat = [...prerje].sort((a, b) => a - b);
  if (pikat.length > maksKapituj) {
    const meHendek = pikat.slice(1)
      .map((i) => ({ i, hendek: momentet[i].vit - momentet[i - 1].vit }))
      .sort((a, b) => b.hendek - a.hendek)
      .slice(0, maksKapituj - 1)
      .map((x) => x.i);
    pikat = [0, ...meHendek].sort((a, b) => a - b);
  }

  return pikat.map((start, idx) => {
    const fund = idx + 1 < pikat.length ? pikat[idx + 1] : momentet.length;
    const pjesa = momentet.slice(start, fund);
    const i_pari = pjesa[0];
    let celes = "periudhe";
    if (idx === 0) celes = "fillimet";
    else if (i_pari.lloj === "zhvendosje") celes = "zhvendosja";
    else if (i_pari.lloj === "brez") celes = "brezi";
    if (idx === pikat.length - 1 && idx !== 0) celes = "sot";
    return {
      id: `k${idx + 1}`,
      nr: idx + 1,
      celes,
      // Vendi që e karakterizon kapitullin — për titullin dhe për hartën.
      vend: i_pari.vend || null,
      nga: pjesa[0].vit,
      deri: pjesa[pjesa.length - 1].vit,
      momentIds: pjesa.map((m) => m.id),
    };
  });
}

// ---------------------------------------------------------------------------
// GJITHÇKA BASHKË
// ---------------------------------------------------------------------------
export function ndertoTregimin({ people, ngjarjet = [], maks = 24, maksKapituj = 6, fusha = null } = {}) {
  // FUSHA PRITET E PARA. Gjithçka poshtë — brezat, vendet, momentet, kapitujt —
  // llogaritet mbi prerjen, jo mbi familjen e plotë. Ndryshe do të kishim një
  // rrëfim që numëron shtatë breza dhe tregon dy.
  const f = zgjidhFushen(people, fusha);
  const brenda = f.people;
  const ev = ngjarjetENjeFushe(ngjarjet, brenda, fusha);

  const momentet = zgjidhMomentet({ people: brenda, ngjarjet: ev, maks });
  const kapitujt = ndajKapitujt(momentet, { maksKapituj });
  const { brezat } = ndajBrezat(brenda);
  const vendet = ndertoUdhetimin(brenda);
  const vitet = momentet.map((m) => m.vit).filter(Boolean);
  return {
    momentet, kapitujt, brezat, vendet,
    nga: vitet.length ? Math.min(...vitet) : null,
    deri: vitet.length ? Math.max(...vitet) : null,
    saPersona: Object.values(brenda).filter(gjalle).length,
    // Fusha udhëton bashkë me rrëfimin: kopertina e librit dhe fjalia e parë e
    // turneut duhet ta thonë se çfarë po tregohet — dhe kur s'u tregua dot, pse.
    fusha: {
      lloj: f.lloj, nga: f.nga, deri: f.deri,
      bosh: f.bosh, arsyeja: f.arsyeja, saJashte: f.saJashte,
      emriNga: f.nga && people?.[f.nga] ? emriPlote(people[f.nga]) : null,
      emriDeri: f.deri && people?.[f.deri] ? emriPlote(people[f.deri]) : null,
    },
  };
}

export const PESHAT = PESHA;
